import { render, staticRenderFns } from "./DynPropBaseDetail.vue?vue&type=template&id=7f5ff010"
import script from "./DynPropBaseDetail.vue?vue&type=script&lang=js"
export * from "./DynPropBaseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports